import { callApi } from "../../api";
import { schema } from "normalizr";

const clinicSchema = new schema.Entity("clinics", {
}, {
  idAttribute: clinic => clinic.id,
});

export const Schemas = {
  CLINIC: clinicSchema,
  CLINIC_ARRAY: [clinicSchema],
};

// api services
export const loadClinics = (useSchema = true, params = {}) =>
  callApi("clinics/",
    {
      method: "GET",
      params,
    }, useSchema ? Schemas.CLINIC_ARRAY : null);

export const loadClinic = (clinicId, filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += filters[item] !== null || filters[item] !== undefined ? `${item}=${filters[item]}&` : "", "?").slice(0, -1) : "";
  return callApi(`clinics/${clinicId}/${queryParams}`, { method: "GET" });
};

export const loadClinicCalendar = (clinicId) => callApi(`clinics/${clinicId}/calendar/`, { method: "GET" });

export const editClinic = (clinicId, clinic) => callApi(`clinics/${clinicId}/`, { method: "PATCH", type: "JSON", body: clinic });

export const createClinic = (clinic, useSchema = true) => callApi("clinics/", {
  method: "POST",
  type: "JSON",
  body: clinic,
}, useSchema ? Schemas.CLINIC : undefined);

export const deleteClinic = (clinicId) => callApi(`clinics/${clinicId}/`, { method: "DELETE" });

export const loadClinicReport = (filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += filters[item] !== null || filters[item] !== undefined ? `${item}=${encodeURIComponent(filters[item])}&` : "", "?").slice(0, -1) : "";
  return callApi(`clinics/reports/${queryParams}`, { method: "GET" });
};

export const loadSpedSchoolReport = () => callApi("clinics/sped_report/", { method: "GET" });
